module.exports = __webpack_public_path__ + "img/finance-application-display-honda.e42b8f7b.png";